import { useActiveOrg } from "@orkestor/core";
import { Navigate, Outlet } from "react-router-dom";

import { HOME_PATH } from "./paths";

/** La puerta de un producto: sus rutas sólo se montan si la organización activa
 *  lo tiene activado.
 *
 *  **Tres estados, no dos**, y es la misma distinción que el selector de producto
 *  ya hace en el Shell:
 *
 *  - **contratado** → se entra;
 *  - **consta que NO lo tiene** → al inicio, sin pantalla rota;
 *  - **no consta** (`undefined`) → se entra igual. No se afirma lo que no se
 *    sabe: una respuesta más vieja que este navegador, o un despliegue a medias,
 *    dejaría a todo el mundo fuera de todos los productos — que es un apagón
 *    causado por la propia puerta, y precisamente lo que no puede hacer.
 *
 *  Redirigir al inicio y no enseñar un «no tienes acceso»: quien llega aquí suele
 *  venir de un enlace guardado de otra organización, y lo útil es devolverlo a
 *  donde sí puede trabajar.
 */
export function ProductoActivo({ producto }: { producto: string }) {
  const { activeOrg } = useActiveOrg();
  const contratados: string[] | undefined = activeOrg?.products ?? undefined;
  if (contratados !== undefined && !contratados.includes(producto)) {
    return <Navigate to={HOME_PATH} replace />;
  }
  return <Outlet />;
}
